var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{ref:"dialog"},[_c('div',{staticClass:"dialog"},[_c('img',{attrs:{"src":"https://source.qunarzz.com/site/images/wns/20220525-shijianchen-dialog.png","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }